import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        workshopsLocales: ['fr'],
        placeCode: undefined,
        placeContext: undefined,
        places: [],
        selectedPlaces: [],
        selectedDate: null,
        searchQuery: '',
        selectedThemes: [],
        priceFilter: null,
        userToken: undefined,
        user: undefined,
        userWorkshops: []
    },
    getters: {
        selectedPlaceCodes(state) {
            return state.selectedPlaces.map(p => p.code)
        }
    },
    mutations: {
        setWorkshopsLocales(state, workshopsLocales) {
            state.workshopsLocales = workshopsLocales
        },
        setPlaceCode(state, placeCode) {
            state.placeCode = placeCode
        },
        resetPlaceCode(state) {
            state.placeCode = undefined
        },
        setPlaceContext(state, placeContext) {
            state.placeContext = placeContext
        },
        setPlaces(state, places) {
            state.places = places
        },
        setSelectedPlaces(state, places) {
            state.selectedPlaces = places
        },
        toggleSelectedPlace(state, place) {
            const index = state.selectedPlaces.findIndex(p => p.code === place.code)
            if (index === -1) {
                state.selectedPlaces.push(place)
            } else {
                state.selectedPlaces.splice(index, 1)
            }
        },
        setSelectedDate(state, date) {
            state.selectedDate = date
        },
        setSearchQuery(state, query) {
            state.searchQuery = query
        },
        setSelectedThemes(state, themes) {
            state.selectedThemes = themes
        },
        toggleSelectedTheme(state, themeUuid) {
            const index = state.selectedThemes.indexOf(themeUuid)
            if (index === -1) {
                state.selectedThemes.push(themeUuid)
            } else {
                state.selectedThemes.splice(index, 1)
            }
        },
        setPriceFilter(state, filter) {
            state.priceFilter = filter
        },
        resetFilters(state) {
            state.searchQuery = ''
            state.selectedThemes = []
            state.priceFilter = null
            state.selectedDate = null
        },
        setUserToken(state, userToken) {
            state.userToken = userToken
        },
        setUser(state, user) {
            state.user = user
        },
        setUserWorkshops(state, userWorkshops) {
            state.userWorkshops = userWorkshops
        },
        addUserWorkshop(state, workshop) {
            state.userWorkshops.push(workshop)
        },
        removeUserWorkshop(state, workshopToRemove) {
            let workshopIndex = state.userWorkshops.findIndex(workshop => workshop.uuid === workshopToRemove.uuid)
            state.userWorkshops.splice(workshopIndex, 1)
        },
    },
    actions: {
        setWorkshopsLocales(context, workshopsLocales) {
            context.commit('setWorkshopsLocales', workshopsLocales)
        },
        setPlaceCode(context, placeCode) {
            context.commit('setPlaceCode', placeCode)
        },
        resetPlaceCode(context) {
            context.commit('resetPlaceCode')
        },
        setPlaceContext(context, placeContext) {
            context.commit('setPlaceContext', placeContext)
        },
        setPlaces(context, places) {
            context.commit('setPlaces', places)
        },
        setSelectedPlaces(context, places) {
            context.commit('setSelectedPlaces', places)
        },
        toggleSelectedPlace(context, place) {
            context.commit('toggleSelectedPlace', place)
        },
        setSelectedDate(context, date) {
            context.commit('setSelectedDate', date)
        },
        setSearchQuery(context, query) {
            context.commit('setSearchQuery', query)
        },
        setSelectedThemes(context, themes) {
            context.commit('setSelectedThemes', themes)
        },
        toggleSelectedTheme(context, themeUuid) {
            context.commit('toggleSelectedTheme', themeUuid)
        },
        setPriceFilter(context, filter) {
            context.commit('setPriceFilter', filter)
        },
        resetFilters(context) {
            context.commit('resetFilters')
        },
        setUserToken(context, userToken) {
            context.commit('setUserToken', userToken)
        },
        setUser(context, user) {
            context.commit('setUser', user)
        },
        setUserWorkshops(context, userWorkshops) {
            context.commit('setUserWorkshops', userWorkshops)
        },
        addUserWorkshop(context, workshop) {
            context.commit('addUserWorkshop', workshop)
        },
        removeUserWorkshop(context, workshop) {
            context.commit('removeUserWorkshop', workshop)
        }
    }
})

export default store
